<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="dedication"></a><a id="page_v"></a>
<p class="dedication" id="ded_p1"><i>This is for Joe Gores</i>,<br/><i>for the hell of it</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?37275eca